import { Button } from '@askable/ui/core/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
} from '@askable/ui/core/dialog';
import { useTranslation } from 'react-i18next';

import type { FC } from 'react';

type Props = {
  open: boolean;
  onClose?: () => void;
};

export const ShareScreenWholeScreenDialog: FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onOpenChange={isOpen => {
        if (!isOpen) {
          onClose?.();
        }
      }}
    >
      <DialogOverlay>
        <DialogContent data-testid="share-screen-whole-screen-required">
          <DialogHeader>{t('permissions.screenShareWholeScreen.title')}</DialogHeader>
          <DialogDescription>{t('permissions.screenShareWholeScreen.description')}</DialogDescription>
          <DialogFooter>
            <Button onClick={onClose}>{t('global.dismiss')}</Button>
          </DialogFooter>
        </DialogContent>
      </DialogOverlay>
    </Dialog>
  );
};
